import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Typography,
  Box,
  IconButton,
  Grid,
} from "@mui/material";
import { IoMdClose } from "react-icons/io";

const Popup = ({ popupData, onClose, lang }) => {
  const [language, setLanguage] = React.useState("en");

  React.useEffect(() => {
    if (lang) {
      lang(language);
    }
  }, [language, lang]);

  if (!popupData) return null;

  return (
    <Dialog
      open={true}
      onClose={onClose}
      maxWidth="md"
      sx={{ opacity: "2" }}
      BackdropProps={{
        style: {
          backgroundColor: "rgba(0, 0, 0, 0.7)", // Pure black with 80% opacity
          backdropFilter: "blur(5px)", // Optional: Adds blur effect
        },
      }}
      PaperProps={{
        style: {
          backgroundColor: "#f8f9fa",
          borderRadius: "10px",
          // border: "2px solid #e0e0e0",
          boxShadow: "0 4px 12px rgba(0,0,0,1)",
        },
      }}
    >
      {/* Green header with language and close button */}
      <DialogTitle
        style={{
          backgroundColor: "#198754",
          color: "white",
          padding: "8px 16px",
          display: "flex",
          // justifyContent: " space-between",
          alignItems: "center",
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          gap={2}
          justifyContent={"space-between"}
          flex={1}
        >
          <Box display="flex" alignItems="center">
            <Typography variant="subtitle2" style={{ marginRight: "8px" }}>
              Available in:
            </Typography>
            <select
              style={{
                padding: "2px 8px",
                borderRadius: "4px",
                backgroundColor: "transparent",
                color: "white",
                border: "1px solid white",
                cursor: "pointer",
                fontSize: "16px",
              }}
              onChange={(e) => setLanguage(e.target.value)}
              value={language}
            >
              <option value="en" className="text-black text-sm">
                English
              </option>
              <option value="hi" className="text-black">
                हिंदी
              </option>
              <option value="bn" className="text-black">
                বাংলা
              </option>
            </select>
          </Box>
          <IconButton
            onClick={onClose}
            style={{
              color: "white",
              padding: "4px",
              marginLeft: "8px",
            }}
          >
            <IoMdClose size={20} />
          </IconButton>
        </Box>
      </DialogTitle>
      {/* Title outside the green header */}
      <Box
        p={2}
        borderBottom="1px solid #198754"
        backgroundColor="rgb(215 212 212)"
      >
        <Typography variant="h5" component="div" style={{ fontWeight: 600 }}>
          {popupData.title}
        </Typography>
      </Box>

      <DialogContent dividers style={{ padding: "20px" }}>
        {popupData.display_image === "above" && popupData.image && (
          <Box mb={3} display="flex" justifyContent="center">
            <img
              src={popupData.image}
              alt={popupData.title}
              style={{
                maxWidth: "100%",
                maxHeight: "300px",
                borderRadius: "8px",
                border: "1px solid #e0e0e0",
                objectFit: "contain",
              }}
            />
          </Box>
        )}

        {popupData.display_image === "below" ? (
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              {popupData.image && (
                <img
                  src={popupData.image}
                  alt={popupData.title}
                  style={{
                    width: "100%",
                    height: "100%",
                    maxHeight: "300px",
                    borderRadius: "8px",
                    border: "1px solid #e0e0e0",
                    objectFit: "contain",
                  }}
                />
              )}
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography
                variant="body1"
                component="div"
                dangerouslySetInnerHTML={{ __html: popupData.description }}
                style={{ color: "#333", lineHeight: "1.6" }}
              />
            </Grid>
          </Grid>
        ) : (
          <Typography
            variant="body1"
            component="div"
            dangerouslySetInnerHTML={{ __html: popupData.description }}
            style={{ color: "#333", lineHeight: "1.6", marginBottom: "16px" }}
          />
        )}

        {popupData.display_image === "beside" && popupData.image && (
          <Box mt={3} display="flex" justifyContent="center">
            <img
              src={popupData.image}
              alt={popupData.title}
              style={{
                maxWidth: "100%",
                maxHeight: "300px",
                borderRadius: "8px",
                border: "1px solid #e0e0e0",
                objectFit: "contain",
              }}
            />
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default Popup;
